<template>
  <section>
    ModalContactForm
  </section>
</template>

<script>
export default {
  name: 'ModalContactForm',

  methods: {
    setModal(componentName) {
      this.$store.dispatch('backOffice/steps/setModalComponent', componentName).then(() => {
        this.$router.push({ name: 'home' })
      })
    },
  },
}
</script>

<style lang="scss"></style>
